export const loanSeniorityTypeList = [
  { name: "Senior", value: "c779ef59-4691-11e9-82f6-0242ac120002" },
  { name: "Subordinate", value: "ca379142-4691-11e9-82f6-0242ac120002" },
  { name: "Supplemental", value: "cd45f985-4691-11e9-82f6-0242ac120002" },
  { name: "Subsidy", value: "39f31887-311c-11ec-97c4-98fa9bde2f84" }
];
export default {
  "SENIOR": "c779ef59-4691-11e9-82f6-0242ac120002",
  "SUBORDINATE": "ca379142-4691-11e9-82f6-0242ac120002",
  "SUPPLEMENTAL": "cd45f985-4691-11e9-82f6-0242ac120002",
  "SUBSIDY": "39f31887-311c-11ec-97c4-98fa9bde2f84"
};

export const seniorityMap = {
  "Senior": "c779ef59-4691-11e9-82f6-0242ac120002",
  "c779ef59-4691-11e9-82f6-0242ac120002": "Senior",

  "Subordinate": "ca379142-4691-11e9-82f6-0242ac120002",
  "ca379142-4691-11e9-82f6-0242ac120002": "Subordinate",

  "Supplemental": "cd45f985-4691-11e9-82f6-0242ac120002",
  "cd45f985-4691-11e9-82f6-0242ac120002": "Supplemental",

  "Subsidy": "39f31887-311c-11ec-97c4-98fa9bde2f84",
  "39f31887-311c-11ec-97c4-98fa9bde2f84": "Subsidy"
};
